import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SEARCH_PAGE } from "../../state/modules/page/constants";
import { getLocation } from "../../state/modules/router/selectors";
import { getPageName } from "../../state/modules/page/selectors";
import { getAdditionalQueryParams } from "../../state/modules/search";
import { updateLocationQuery } from "../../state/modules/router/actions";

const isBareSearchLocation = (pageName, query = {}) => {
  const queryParams = Object.keys(query);

  return (
    pageName === SEARCH_PAGE &&
    queryParams.length === 1 &&
    queryParams[0] === "q"
  );
};

// Persist server-inferred floor filters only while the URL is still a bare search.
export const useUpdateRefineParameters = ({ searchTerm }) => {
  const dispatch = useDispatch();
  const location = useSelector(getLocation);
  const pageName = useSelector(getPageName);
  const additionalQueryParams = useSelector(getAdditionalQueryParams);

  useEffect(() => {
    if (!isBareSearchLocation(pageName, location?.query)) {
      return;
    }

    const refine = additionalQueryParams?.refine;

    if (refine) {
      dispatch(updateLocationQuery({ query: { refine } }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);
};
